module.exports = __webpack_public_path__ + "assets/img/34-l.6ca3cea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/34-l.jpg
// module id = 8rCB
// module chunks = 0